import { Link } from "react-router-dom";
import { usePermissionsStore } from "../permissions/permissions_store";
import { REQUIREMENTS } from "./catalog";

export const SubscriptionRequirement = ({ feature, className = "" }) => (
  <div className={`rbr-feature-requirement ${className}`.trim()}>
    <span className={feature.requirement === "texting" ? "secondary" : undefined}>{feature.requirement === "confirm" ? REQUIREMENTS.confirm : `Requires ${REQUIREMENTS[feature.requirement]}`}</span>
    {feature.paidAddon && <span className="rbr-feature-badge">Paid add-on</span>}
  </div>
);

export const FEATURE_ROUTE_MODULES = {
  '/properties': 'guides.home', '/areas': 'guides.area', '/extras': 'guides.extras',
  '/payments': 'guides.payments', '/guide-designer': 'guides.master',
  '/scheduler': 'messaging.scheduler', '/messages': 'messaging.messages',
  '/settings/chat': 'messaging.chatbot', '/settings/five-star': 'messaging.surveys',
  '/contacts': 'messaging.contacts', '/alerts': 'messaging.alerts', '/saved-responses': 'messaging.responses',
  '/settings/integrations': 'admin.settings', '/surveys': 'messaging.surveys',
  '/extend-guest-stay': 'messaging.extend_stay', '/smart-locks': 'admin.integrations',
  '/operations': 'operations.calendar', '/operations/storage': 'operations.inventory',
};

export const FeatureAction = ({ feature }) => {
  const { canView, canEdit, permsLoaded } = usePermissionsStore();
  const module = FEATURE_ROUTE_MODULES[feature.path.split('?')[0]];
  const allowed = permsLoaded && module && (feature.admin || feature.path.startsWith('/guide-designer') ? canEdit(module) : canView(module));
  return allowed
    ? <Link className="uk-button hms-btn hms-red-btn uk-flex-inline uk-flex-middle" to={feature.path}>{feature.action}</Link>
    : <span className="rbr-feature-admin">Ask your account administrator for access to this feature.</span>;
};
